import { Route } from 'types/route.type';
import SitesOverview from 'views/playground/features/my-supply-plan/components/sites-overview';
import { routes as mySupplyPlan } from 'views/playground/features/my-supply-plan/features/ofd-1.0/routes';
import { routes as ofd } from 'views/playground/features/my-supply-plan/features/ofd-2.0/routes';

export const routes: Route[] = [
  {
    path: '/playground/supply-plan/:siteTab?',
    component: SitesOverview,
  },
  ...ofd,
  ...mySupplyPlan,
];
